import React from "react";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";
import CancelIcon from "@mui/icons-material/Close";

import SelectQuarter from "components/smea/Textfields/SelectQuarter";
import SchoolYearDatePicker from "components/smea/Textfields/SchoolYearDatePicker";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  //   height: "80vh",
  width: "40vw",
  minWidth: "500px",
  transform: "translate(-50%, -50%)",
  bgcolor: "#f0f0f0",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.3)",
  borderRadius: "10px",
  p: 4,
};

export default function FilterModal({
  open,
  handleClose,
  schoolYear,
  setSchoolYear,
  quarter,
  setQuarter,
  handleFilter,
  error,
}) {
  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Box sx={style}>
        <Box
          sx={{
            position: "absolute",
            right: 20,
            cursor: "pointer",
            zIndex: 100,
          }}
        >
          <IconButton onClick={handleClose} sx={{ p: 0 }}>
            <CancelIcon />
          </IconButton>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ fontSize: "30px", fontWeight: "bold", mb: 4 }}>
            Filter
          </Typography>

          {error && (
            <Box
              sx={{
                width: "100%",
                backgroundColor: "red",
                pl: 2,
                mb: 2,
              }}
            >
              <Typography
                sx={{
                  color: "lightgray",
                  fontWeight: "bolder",
                  fontSize: "15px",
                }}
              >
                {error}
              </Typography>
            </Box>
          )}

          <Box
            sx={{
              width: "100%",
              mb: 2,
            }}
          >
            <Box sx={{ display: "block", mb: 2 }}>
              <Typography>School Year:</Typography>
              <SchoolYearDatePicker
                schoolYear={schoolYear}
                setSchoolYear={setSchoolYear}
              />
            </Box>
            <Box sx={{ width: "100%", mb: 4 }}>
              <Typography>Quarter:</Typography>
              <SelectQuarter
                placeholder="Select Quarter"
                name="quarter"
                value={quarter}
                onChange={(fieldName, selectedValue) => {
                  setQuarter(selectedValue);
                }}
                sx={{
                  width: "100%",
                  "&:hover": {
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "black !important",
                    },
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            disabled={!schoolYear || !quarter}
            onClick={() => {
              handleFilter();
              handleClose();
            }}
            variant="contained"
            sx={{
              borderRadius: "10px",
              backgroundColor: "lightgray",
              color: "black",
              fontSize: "15px",
              padding: "8px 5px",
              margintop: "15px",
              width: "150px",
              height: "40px",
              mx: 2,
              "&:hover": {
                backgroundColor: "#2031C9",
                color: "#fff",
                fontWeight: "bolder",
              },
            }}
          >
            <FilterListIcon sx={{ mr: 1 }} />
            Filter
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
